// Find my dress quiz: asks a few questions, scores every in-stock dress, then loads the best matches as collection cards
(function () {
  document.querySelectorAll('[data-fmd-root]').forEach(function (root) {
    var dialog = root.querySelector('[data-fmd-dialog]');
    var resultsWrap = root.querySelector('[data-fmd-results-wrap]');
    var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    var maxResults = parseInt(root.getAttribute('data-fmd-max'), 10) || 8;

    // Questions. Each answer adds or takes away points from dresses with matching traits.
    var QUESTIONS = [
      { id: 'occasion', q: 'Where will you wear it most?', hint: 'Pick the one that fits best.', options: [
        { v: 'everyday', label: 'Everyday', sub: 'Errands, school run, coffee' },
        { v: 'work', label: 'Work', sub: 'Office days and meetings' },
        { v: 'weekend', label: 'Weekends & holidays', sub: 'Long lunches, travel, the beach' },
        { v: 'event', label: 'Dinners & events', sub: 'Something a little special' }
      ] },
      { id: 'fabric', q: 'Denim, print or plain?', options: [
        { v: 'denim', label: 'Denim & chambray' },
        { v: 'print', label: 'A pretty print' },
        { v: 'plain', label: 'Plain colour' },
        { v: 'any', label: 'Happy with any' }
      ] },
      { id: 'length', q: 'Your favourite length?', options: [
        { v: 'mini', label: 'Mini', sub: 'Above the knee' },
        { v: 'midi', label: 'Midi', sub: 'Below the knee' },
        { v: 'maxi', label: 'Maxi', sub: 'Down to the ankle' },
        { v: 'any', label: 'No preference' }
      ] },
      { id: 'shape', q: 'Buttons or no buttons?', options: [
        { v: 'shirt', label: 'Shirtdress', sub: 'Collar, buttons down the front' },
        { v: 'pull', label: 'Pull-on dress', sub: 'No buttons to fuss with' },
        { v: 'any', label: 'Either' }
      ] },
      { id: 'colour', q: 'Which colours do you reach for?', options: [
        { v: 'blue', label: 'Blues', sub: 'Light blue to indigo and navy' },
        { v: 'neutral', label: 'Neutrals', sub: 'Black, white, ecru, khaki, chocolate' },
        { v: 'colour', label: 'Rich colour', sub: 'Greens, berry, rust, mustard' },
        { v: 'any', label: 'Anything goes' }
      ] },
      { id: 'sleeves', q: 'Sleeves?', options: [
        { v: 'long', label: 'Long sleeves' },
        { v: 'short', label: 'Short or sleeveless' },
        { v: 'any', label: "Don't mind" }
      ] },
      { id: 'height', q: 'How tall are you?', hint: 'Our petite styles are cut for 157cm and under.', options: [
        { v: 'petite', label: "157cm (5'2\") & under", sub: 'Show me petite fits' },
        { v: 'standard', label: "Over 157cm (5'2\")" }
      ] }
    ];

    var LABELS = { occasion: {}, fabric: {}, length: {}, shape: {}, colour: {}, sleeves: {}, height: {} };
    QUESTIONS.forEach(function (q) { q.options.forEach(function (o) { LABELS[q.id][o.v] = o.label; }); });

    // Work out each dress's traits from its title and tags
    var BLUES = /BLUE|INDIGO|NAVY|CORNFLOWER|SKY|TEAL|AZUR|CHAMBRAY/;
    var NEUTRALS = /BLACK|WHITE|ECRU|KHAKI|CHOCOLATE|CHARCOAL|CAMEL|SAND|STONE|LATTE|MOCHA|OLIVE|ALMOND|CREAM|NATURAL/;
    var COLOURS = /RASPBERRY|TANGERINE|WINE|BERRY|FOREST|EMERALD|GINGER|MUSTARD|GREEN|CHART|JUNGLE|RUSSET|TERRACOTTA|RED|PINK|ORANGE|LILAC/;
    var dresses = [];
    root.querySelectorAll('[data-fmd-card]').forEach(function (el, i) {
      var t = (el.getAttribute('data-title') || '').toUpperCase();
      var tags = (el.getAttribute('data-tags') || '').toUpperCase().split('|');
      var parts = t.split(' - ');
      var colour = parts.slice(1).join(' ').replace(/PETITE|CURVE/g, '');
      var d = {
        handle: el.getAttribute('data-fmd-card'), i: i, style: parts[0],
        denim: /DENIM|CHAMBRAY/.test(t),
        print: /PRINT|STRIPE|CHECK|GINGHAM/.test(t),
        twoTone: colour.indexOf('/') > -1,
        mini: /\bMINI\b/.test(t),
        maxi: /\bMAXI\b/.test(t) || tags.indexOf('MAXI') > -1,
        shirt: /SHIRTDRESS|SHIRT DRESS/.test(t),
        jersey: /JERSEY/.test(t),
        long: /LONG SLEEVE/.test(t),
        petite: /PETITE/.test(t),
        curve: /CURVE/.test(t)
      };
      d.midi = !d.mini && !d.maxi;
      d.blue = BLUES.test(colour) || (d.denim && !NEUTRALS.test(colour) && !COLOURS.test(colour));
      d.neutral = !d.print && !d.blue && NEUTRALS.test(colour);
      d.colour = !d.print && !d.blue && !d.neutral && COLOURS.test(colour);
      dresses.push(d);
    });
    var hasPetite = {};
    dresses.forEach(function (d) { if (d.petite) hasPetite[d.style] = true; });

    var qcount = root.querySelector('[data-fmd-qcount]');
    if (qcount) qcount.textContent = QUESTIONS.length;
    var dcount = root.querySelector('[data-fmd-dcount]');
    if (dcount) dcount.textContent = dresses.length;

    function score(d, a) {
      var s = 0, why = [];
      // Occasion
      if (a.occasion === 'everyday') { if (d.denim) s += 2; if (d.shirt) s += 1; if (d.jersey) s += 2; if (d.midi) s += 1; }
      if (a.occasion === 'work') { if (d.shirt) s += 2; if (d.midi) s += 2; if (d.long) s += 1; if (d.mini) s -= 3; if (d.blue || d.neutral) s += 1; }
      if (a.occasion === 'weekend') { if (d.mini) s += 2; if (d.print || d.twoTone) s += 1; if (d.denim) s += 1; if (d.jersey) s += 1; }
      if (a.occasion === 'event') { if (d.print) s += 2; if (!d.denim) s += 1; else s -= 1; if (d.maxi) s += 2; if (d.colour) s += 1; if (d.jersey) s -= 1; }
      // Fabric
      if (a.fabric === 'denim') { if (d.denim) { s += 5; why.push('Denim'); } else s -= 4; }
      if (a.fabric === 'print') { if (d.print) { s += 5; why.push('Print'); } else if (d.twoTone) s += 2; else s -= 4; if (d.denim) s -= 1; }
      if (a.fabric === 'plain') { if (!d.print && !d.twoTone && !d.denim) { s += 4; why.push('Plain colour'); } else if (d.print) s -= 4; else s -= 1; }
      // Length
      if (a.length === 'mini') { if (d.mini) { s += 5; why.push('Mini'); } else s -= 5; }
      if (a.length === 'midi') { if (d.midi) { s += 5; why.push('Midi'); } else if (d.maxi) s -= 1; else s -= 5; }
      if (a.length === 'maxi') { if (d.maxi) { s += 5; why.push('Maxi'); } else if (d.midi) s += 1; else s -= 5; }
      // Shape
      if (a.shape === 'shirt') { if (d.shirt) { s += 3; why.push('Shirtdress'); } else s -= 2; }
      if (a.shape === 'pull') { if (!d.shirt) { s += 3; why.push('Pull-on'); } else s -= 2; }
      // Colour
      if (a.colour !== 'any' && a.colour && d[a.colour]) { s += 3; why.push(LABELS.colour[a.colour]); }
      else if (a.colour !== 'any' && a.colour && !d.print) s -= 1;
      // Sleeves
      if (a.sleeves === 'long') { if (d.long) { s += 3; why.push('Long sleeves'); } }
      if (a.sleeves === 'short' && d.long) s -= 3;
      // Height: petite versions win a close call, but not over the colour she asked for
      if (d.petite && a.height === 'petite') { s += 2; why.push('Petite fit'); }
      // Keep the shop's own order as a tie-breaker
      s -= d.i * 0.01;
      return { s: s, why: why };
    }

    function rank(a) {
      var list = dresses.filter(function (d) {
        if (d.curve) return false;
        if (a.height === 'petite') return d.petite || !hasPetite[d.style];
        return !d.petite;
      }).map(function (d) { var r = score(d, a); return { d: d, s: r.s, why: r.why }; });
      list.sort(function (x, y) { return y.s - x.s; });
      // At most two colours of the same style, so the results show a range
      var perStyle = {}, out = [];
      for (var k = 0; k < list.length && out.length < maxResults; k++) {
        var st = list[k].d.style;
        perStyle[st] = (perStyle[st] || 0) + 1;
        if (perStyle[st] <= 2) out.push(list[k]);
      }
      return out;
    }

    // Collection cards come from the product.fmd-card template, one request per match.
    // On a preview theme the request has to name the theme, or the live theme answers.
    var cards = {};
    var theme = window.Shopify && Shopify.theme;
    var preview = theme && theme.role !== 'main' ? theme.id : null;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function loadCard(handle) {
      if (!cards[handle]) {
        var url = base + 'products/' + handle + '?view=fmd-card' + (preview ? '&preview_theme_id=' + preview : '');
        cards[handle] = fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      }
      return cards[handle];
    }

    // Quiz flow
    var stepEl = root.querySelector('[data-fmd-step]');
    var qEl = root.querySelector('[data-fmd-question]');
    var hintEl = root.querySelector('[data-fmd-hint]');
    var optsEl = root.querySelector('[data-fmd-options]');
    var backBtn = root.querySelector('[data-fmd-back]');
    var progress = root.querySelector('[data-fmd-progress]');
    var answers = {}, current = 0, opener = null;

    function render() {
      var q = QUESTIONS[current];
      stepEl.textContent = 'Question ' + (current + 1) + ' of ' + QUESTIONS.length;
      progress.style.width = (current / QUESTIONS.length * 100) + '%';
      qEl.textContent = q.q;
      hintEl.textContent = q.hint || '';
      hintEl.hidden = !q.hint;
      backBtn.hidden = current === 0;
      optsEl.innerHTML = '';
      q.options.forEach(function (o) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fmd-option';
        b.setAttribute('aria-pressed', answers[q.id] === o.v ? 'true' : 'false');
        b.innerHTML = '<span class="fmd-option__label"></span>' + (o.sub ? '<span class="fmd-option__sub"></span>' : '');
        b.querySelector('.fmd-option__label').textContent = o.label;
        if (o.sub) b.querySelector('.fmd-option__sub').textContent = o.sub;
        b.addEventListener('click', function () { choose(q.id, o.v); });
        li.appendChild(b);
        optsEl.appendChild(li);
      });
      qEl.focus();
    }

    function choose(id, v) {
      answers[id] = v;
      if (current < QUESTIONS.length - 1) { current++; render(); return; }
      progress.style.width = '100%';
      finish();
    }

    function open(e) {
      opener = e && e.currentTarget;
      answers = {}; current = 0;
      render();
      if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      qEl.focus();
    }
    function close() {
      if (dialog.open) dialog.close();
    }
    dialog.addEventListener('close', function () { if (opener && !resultsWrap.contains(document.activeElement) && document.activeElement !== resultsWrap) opener.focus(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });

    root.querySelectorAll('[data-fmd-open]').forEach(function (b) { b.addEventListener('click', open); });
    root.querySelector('[data-fmd-close]').addEventListener('click', close);
    backBtn.addEventListener('click', function () { if (current > 0) { current--; render(); } });

    // Results
    var grid = root.querySelector('[data-fmd-results]');
    var answersEl = root.querySelector('[data-fmd-answers]');
    var run = 0;

    function showResults(a) {
      var picks = rank(a), mine = ++run;
      answersEl.innerHTML = '';
      QUESTIONS.forEach(function (q) {
        var v = a[q.id];
        if (!v || v === 'any') return;
        var chip = document.createElement('li');
        chip.className = 'fmd-chip';
        chip.textContent = LABELS[q.id][v];
        answersEl.appendChild(chip);
      });
      grid.innerHTML = '';
      grid.setAttribute('aria-busy', 'true');
      resultsWrap.hidden = false;
      Promise.all(picks.map(function (r) { return loadCard(r.d.handle); })).then(function (htmls) {
        if (mine !== run) return;
        var shown = 0;
        htmls.forEach(function (html, n) {
          var tpl = document.createElement('template');
          tpl.innerHTML = (html || '').trim();
          var li = tpl.content.firstElementChild;
          if (!li || !li.classList.contains('facet-product-grid__item')) return;
          if (shown === 0) {
            var best = document.createElement('span');
            best.className = 'fmd-results__best';
            best.textContent = 'Best match';
            li.appendChild(best);
          }
          if (picks[n].why.length) {
            var why = document.createElement('p');
            why.className = 'fmd-results__why';
            why.textContent = picks[n].why.join(' · ');
            li.appendChild(why);
          }
          grid.appendChild(li);
          shown++;
        });
        grid.removeAttribute('aria-busy');
      });
    }

    function finish() {
      close();
      showResults(answers);
      // Keep the answers in the address so the results survive a refresh or can be shared
      try {
        var params = new URLSearchParams(location.search);
        QUESTIONS.forEach(function (q) { params.set(q.id, answers[q.id]); });
        history.replaceState(null, '', location.pathname + '?' + params.toString() + '#' + resultsWrap.id);
      } catch (err) {}
      resultsWrap.scrollIntoView({ behavior: smooth, block: 'start' });
      resultsWrap.focus({ preventScroll: true });
    }

    // Answers already in the address: show results straight away
    try {
      var params = new URLSearchParams(location.search), saved = {}, all = true;
      QUESTIONS.forEach(function (q) {
        var v = params.get(q.id);
        if (v && LABELS[q.id][v]) saved[q.id] = v; else all = false;
      });
      if (all) showResults(saved);
    } catch (err) {}
  });
})();